import { Assessment } from '@/models/assessment.model';

export interface AssessmentState {
  assessments: Assessment[];
  assessmentDetails: Assessment | undefined;
}

const state: AssessmentState = {
  assessments: [],
  assessmentDetails: undefined,
};

export default state;
